import React, { useState } from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    question: "How does Workman Naija work?",
    answer:
      "Search for a handyman by state, LGA and service type (or find someone near you using your location). You'll see their profile, price, experience and reviews before you book - no waiting around for quotes.",
  },
  {
    question: "Do I pay a fee to search or post a job?",
    answer:
      "No. Searching for a handyman and posting what you need is free for customers.",
  },
  {
    question: "How do I pay for a job?",
    answer:
      "Payments are handled securely through Paystack once your booking is confirmed. You'll see a \"Pay Now\" option on your booking from your dashboard.",
  },
  {
    question: "How do I know a handyman is legitimate?",
    answer:
      "Providers list their experience, pricing and business details on their profile, and customers can leave ratings and reviews after a completed job. Look at a provider's rating and past reviews before booking.",
  },
  {
    question: "I'm a handyman - how do I get work through the platform?",
    answer:
      "Register as a provider with your service type, location and pricing. Customers searching in your area will be able to find and book you directly.",
  },
  {
    question: "Can I cancel a booking?",
    answer:
      "Yes, bookings that are pending or confirmed can be cancelled from your dashboard.",
  },
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="bg-gray-50 min-h-screen py-16">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-2 text-center">
          Frequently Asked Questions
        </h1>
        <p className="text-gray-600 mb-10 text-center">
          Can't find what you're looking for?{" "}
          <Link to="/contact" className="text-green-700 font-medium hover:underline">
            Contact us
          </Link>
          .
        </p>

        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = index === openIndex;
            return (
              <div
                key={faq.question}
                className="bg-white rounded-lg border border-gray-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="w-full flex items-center justify-between text-left px-5 py-4"
                >
                  <span className="font-medium text-gray-900">
                    {faq.question}
                  </span>
                  <span className="text-green-600 text-xl flex-shrink-0 ml-4">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>
                {isOpen && (
                  <p className="text-gray-600 text-sm px-5 pb-4">
                    {faq.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
